import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.js"
import '@fortawesome/fontawesome-free/js/all.js';

import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import store from "@/store/vuex.js";
const app = createApp(App);

app.use(store);
app.use(router);


app.mount('#app');

